import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output,ElementRef} from '@angular/core';
import {CommonService} from '../../common.service';
declare var $ :any;

@Component({
  selector: 'app-case-practice-scene-change',
  templateUrl: './case-practice-scene-change.component.html',
  styleUrls: ['./case-practice-scene-change.component.css']
})
export class CasePracticeSceneChangeComponent implements OnInit , AfterViewInit {
  @Output() onFinish = new EventEmitter<any>();

  clickAble: boolean = false; //按钮点击判断
  constructor(private commonService: CommonService,private el:ElementRef) {}


  ngOnInit() {
    this.setIsWrapClickedVal('.timeCount');
  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor': 'transparent'
    });
  }



  goNext(){
    if(!this.clickAble){
      return false;
    }else{
      this.onFinish.emit('sceneChange');
      this.clickAble = false;
    }
  }

  //根据动画播放结束设置点击判断
  setIsWrapClickedVal(dom){
    let animateEndingElement = this.el.nativeElement.querySelector(dom);
    animateEndingElement.addEventListener('animationend',()=>{
      // if(!this.clickAble){
      //   this.clickAble = true;
      // }
      setTimeout(()=>{
        this.onFinish.emit('sceneChange');
      },300);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-scene-change/case-practice-scene-change.component.ts